import { Figure } from 'react-bootstrap';

function Footer() {
    return(
        <footer className="footer py-3">
            
            <Figure.Caption>
            <b>ติดต่อเรา</b><br/><br/>
            งานเทคโนโลยีสารสนเทศ สำนักวิทยบริการและเทคโนโลยีสารสนเทศ<br/>
            มหาวิทยาลัยเทคโนโลยีราชมงคลอีสาน<br/>

            744 ถ.สุรนารายณ์ ต.ในเมือง อ.เมือง จ.นครราชสีมา 30000<br/>
            เบอร์โทรศัพท์ : 044-233000 ต่อ 2800 e-mail : ita@rmuti.ac.th<br/>

            {/*©2022 RMUTI API All rights reserved.*/}
            </Figure.Caption>
        </footer>
    )
}

export default Footer;